<template>
  <div>
    <div v-if="showrrprice">
      <label>RRP:</label>
      <span class="retail-price">
        {{ rrpprice | currency }}
      </span>
    </div>
    <div>
      <label>Price:</label>
      <span class="sale-price">
        {{ sellPrice | currency }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ecommerce-product-price',
  props: {
    'item': {
      type: Object,
      required: true
    },
    showrrprice: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    rrpprice: function() {
      return parseFloat(this.item.rrp).toFixed(2)
    },
    sellPrice: function() {
      // if (this.item.product_settings != null) {
      //   return (parseFloat(this.item.product_settings.prices.base_price) + parseFloat(this.$store.getters['ecommerce/getTotalPriceAdjustment'](this.item))).toFixed(2)
      // }
      // else {
      return (parseFloat(this.item.productsettings.prices.base_price) + parseFloat(this.$store.getters['ecommerce/getTotalPriceAdjustment'](this.item))).toFixed(2)
      // }
    }
  }
}
</script>

<style scoped>

</style>
